export default "__VITE_ASSET__DFqKcXmy__"